type ServerSessionRejectionListener = () => void;

const listeners = new Set<ServerSessionRejectionListener>();

/**
 * Registers what an auth integration does when the server no longer accepts
 * the session of this browser: it closed the realtime connection with 4403
 * (a revoked or expired session or token, a ban), or refused an operation
 * as signed out. Better Auth reads the session again, OIDC asks the backend
 * and renews an expired token.
 *
 * @returns A function that unregisters the listener again.
 */
export function onServerSessionRejected(
  listener: ServerSessionRejectionListener,
): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Tells every registered auth integration that the server rejected the session. */
export function reportServerSessionRejected(): void {
  for (const listener of listeners) {
    try {
      listener();
    } catch (error) {
      // One failing listener must not keep the others from running.
      console.error("Session rejection listener failed", error);
    }
  }
}
